
import { AuthorModalOptions } from '@/types/modalTypes'
import { defineComponent, PropType } from 'vue'
import SqlView from '../SqlView.vue'

export default defineComponent({
  name: 'AuthorModalContent',
  components: {
    SqlView
  },
  emits: ['back'],
  props: {
    options: Object() as PropType<AuthorModalOptions>
  },
  computed: {
    sql() {
      if (this.options)
        return `SELECT paper_id, doi, authors, title, published_year, adamic_adar + COALESCE(cocite, 0) as similarity, num_cited_by\nFROM papers p\nWHERE {{filters}} AND p.paper_id IN (SELECT paper_id FROM authors WHERE name = "${this.options.author.name}") ORDER BY similarity DESC, published_year DESC`
      else return ''
    }
  }
})
